import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	label: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.restricted-field-group.label',
		defaultMessage: 'Fields unavailable in the issue view',
		description:
			'Label of expandable section for restricted fields group which appears in the RHS panel when search results return restricted fields',
	},
	labelIssueTermRefresh: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.restricted-field-group.label-issue-term-refresh',
		defaultMessage: 'Fields unavailable in the work item view',
		description:
			'Label of expandable section for restricted fields group which appears in the RHS panel when search results return restricted fields',
	},
	descriptionGlobalAdmin: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.restricted-field-group.description-global-admin',
		defaultMessage:
			'These fields will not be available in the issue view even if you drag them to the issue layout as the fields don’t have a global context. <link>See why fields aren’t visible in the issue view.</link>',
		description: `Helpful message explaining what restricted fields are which appears when restricted group label is clicked and the group is expanded.
            <link></link> defines a place where documentation link will be inserted in the UI.`,
	},
	descriptionGlobalAdminIssueTermRefresh: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.restricted-field-group.description-global-admin-issue-term-refresh',
		defaultMessage:
			'These fields will not be available in the work item view even if you drag them to the work item layout as the fields don’t have a global context. <link>See why fields aren’t visible in the work item view.</link>',
		description: `Helpful message explaining what restricted fields are which appears when restricted group label is clicked and the group is expanded.
            <link></link> defines a place where documentation link will be inserted in the UI.`,
	},
	descriptionNonGlobalAdmin: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.restricted-field-group.description-non-global-admin',
		defaultMessage:
			'These fields will not be available in the issue view even if you drag them to the issue layout as the fields don’t have a global context. <link>Reach out to your Jira admin.</link>',
		description: `Helpful message explaining what restricted fields are which appears when restricted group label is clicked and the group is expanded.
            <link></link> defines a place where documentation link will be inserted in the UI.`,
	},
	descriptionNonGlobalAdminIssueTermRefresh: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.restricted-field-group.description-non-global-admin-issue-term-refresh',
		defaultMessage:
			'These fields will not be available in the work item view even if you drag them to the work item layout as the fields don’t have a global context. <link>Reach out to your Jira admin.</link>',
		description: `Helpful message explaining what restricted fields are which appears when restricted group label is clicked and the group is expanded.
            <link></link> defines a place where documentation link will be inserted in the UI.`,
	},
});
